import { render, staticRenderFns } from "./OfflineModePage.vue?vue&type=template&id=baa4cf4c&scoped=true&"
import script from "./OfflineModePage.vue?vue&type=script&lang=js&"
export * from "./OfflineModePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa4cf4c",
  null
  
)

export default component.exports